import React from 'react'
import styles from "./popularCat.module.css"
import { Border } from '../../../components/maincomps/border/Border'
import { useNavigate } from 'react-router-dom'

const PopularCat = ({ categoriesData, }) => {

    const navigate = useNavigate()

    if (categoriesData?.length <= 0) {
        return (
            <div>
                No Categories found
            </div>
        )
    }
    return (
        <>
            <Border title='Popular categories' subtitle='Find all the trending category' />

            <div className={styles.gallery}>

                <div className={styles.col}>
                    <img src={categoriesData[0]?.thumbnailPhoto ? categoriesData[0]?.thumbnailPhoto : '/assets/about.png'} alt="Jewelry1" />
                    <div className={styles.imagetitle}>
                        <h2>{categoriesData[0]?.name}</h2>
                        <p>{categoriesData[0]?.description}</p>
                        <div
                            className={styles.shopNow}
                            onClick={() => {
                                navigate(`/product/${categoriesData[0]?._id}`,
                                    { state: categoriesData[0]?.name })
                                window.scrollTo(0, 0);
                            }}
                        >
                            Shop Now</div>
                    </div>
                </div>

                <div className={styles.col2}>
                    <div className={styles.row1}>
                        <img src={categoriesData[1]?.thumbnailPhoto} alt="JewelryImage 1" />
                        <div className={styles.imagetitle}>
                            <h2>{categoriesData[1]?.name}</h2>
                            <p>{categoriesData[1]?.description}</p>
                            <div className={styles.shopNow}
                                onClick={() => {
                                    navigate(`/product/${categoriesData[1]?._id}`,
                                        { state: categoriesData[1]?.name })
                                    window.scrollTo(0, 0);
                                }

                                }
                            >Shop Now</div>
                        </div>
                    </div>
                    <div className={styles.row}>
                        <img src={categoriesData[2]?.thumbnailPhoto} alt="JewelryImage 1" />
                        <div className={styles.imagetitle}>
                            <h2>{categoriesData[2]?.name}</h2>
                            <p>{categoriesData[2]?.description}</p>
                            <div className={styles.shopNow}
                                onClick={() => {
                                    navigate(`/product/${categoriesData[2]?._id}`,
                                        { state: categoriesData[2]?.name })
                                    window.scrollTo(0, 0);
                                }}
                            >Shop Now</div>
                        </div>
                    </div>
                </div>
                <div className={styles.col2}>
                    <div className={styles.row}>
                        <img src={categoriesData[3]?.thumbnailPhoto} alt="JewelryImage 1" />
                        <div className={styles.imagetitle}>
                            <h2>{categoriesData[3]?.name}</h2>
                            <p>{categoriesData[3]?.description}</p>
                            <div className={styles.shopNow}
                                onClick={() => {
                                    navigate(`/product/${categoriesData[3]?._id}`,
                                        { state: categoriesData[3]?.name })
                                    window.scrollTo(0, 0);
                                }}>
                                Shop Now</div>
                        </div>
                    </div>
                    <div className={styles.row1}>
                        <img src={categoriesData[4]?.thumbnailPhoto} alt="JewelryImage 1" />
                        <div className={styles.imagetitle}>
                            <h2>{categoriesData[4]?.name}</h2>
                            <p>{categoriesData[4]?.description}</p>
                            <div className={styles.shopNow}
                                onClick={() => {
                                    navigate(`/product/${categoriesData[4]?._id}`,
                                        { state: categoriesData[4]?.name })
                                    window.scrollTo(0, 0);
                                }}
                            >Shop Now</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.mobileView}>
                {categoriesData?.map((item, index) => (
                    <div className={styles.col}>
                        <img src={item?.thumbnailPhoto ? item?.thumbnailPhoto : '/assets/about.png'} alt="Jewelry1" />
                        <div className={styles.imagetitle}>
                            <h2>{item?.name}</h2>
                            <p>{item?.description}</p>
                            <div
                                className={styles.shopNow}
                                onClick={() => {
                                    navigate(`/product/${item?._id}`,
                                        { state: item?.name })
                                    window.scrollTo(0, 0);
                                }} >Shop Now</div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default PopularCat